import { FC } from 'react';

import { COLORS } from '@/shared/constants/colors';
import { BeneficiaryGroup as BeneficiaryGroupType } from '@/shared/lib/sj-orm/models/beneficiary.dto';
import { Icon, IconSize } from '@/shared/uikit/Icon';

import { useI18nValues } from '../hooks/useI18nValues';

type PidTypeProps = {
  group: BeneficiaryGroupType;
  showIcon?: boolean;
  iconSize?: IconSize;
};

const GroupIcons = {
  [BeneficiaryGroupType.FAMILY]: (size: IconSize) => (
    <Icon style={{ color: COLORS.systemDark200 }} name="users" size={size} />
  ),
  [BeneficiaryGroupType.FAMILY_CLAN]: (size: IconSize) => (
    <Icon style={{ color: COLORS.systemDark200 }} name="users-four" size={size} />
  ),
  [BeneficiaryGroupType.CIRCLE]: (size: IconSize) => (
    <Icon style={{ color: COLORS.systemDark200 }} name="circle-notch" size={size} />
  ),
};

export const BeneficiaryGroupI18n: FC<PidTypeProps> = ({ group, showIcon, iconSize = 's20' }) => {
  const values = useI18nValues();

  return showIcon ? (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      {GroupIcons[group](iconSize)} {values.group(group)}
    </div>
  ) : (
    values.group(group)
  );
};
